import { createAction, props } from '@ngrx/store';
import {
    ReplyToSubmittalNote,
    SubmittalClientNote
} from 'src/app/accountmanagers/submittals/model/am-submittals.model';

export const setSubmittalClientNotesFilter = createAction(
    '[CLIENT SUBMITTAL NOTES] Set Filter',
    props<{ submittalIds: number[] }>()
);

export const loadSubmittalClientNotesSuccess = createAction(
    '[CLIENT SUBMITTAL NOTES] Load Client Submittal Notes Success',
    props<{ notes: SubmittalClientNote[] }>()
);

export const loadSubmittalClientNotesFail = createAction('[CLIENT SUBMITTAL NOTES] Client Submittal Notes Fail');

export const postSubmittalReply = createAction(
    '[CLIENT SUBMITTAL NOTES] Post Submittal Reply',
    props<{ submittalId: number; replyParams: ReplyToSubmittalNote }>()
);

export const postSubmittalReplySuccess = createAction('[CLIENT SUBMITTAL NOTES] Post Submittal Reply Success');

export const postSubmittalReplyFail = createAction(
    '[CLIENT SUBMITTAL NOTES] Post Submittal Reply Fail',
    props<{ error: unknown }>()
);
